<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-基础设置
      -->
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启交易组件" prop="is_open">
        <el-switch v-model="form.is_open">
        </el-switch>
      </el-form-item>
      <el-form-item label="默认退货地址">
        <el-select v-model="form.address_id" placeholder="请选择地址">
          <el-option v-for="(item, index) in address" :key="index" :label="item.fulladdress" :value="item.address_id"></el-option>
        </el-select>
      </el-form-item>

      <!--提交-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
  import MinistoreApi from '@/api/ministore.js';
  export default {
    data() {
      return {
        form: {
          is_open: false
        },
        setting: [],
        loading: false,
        address:[]
      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        MinistoreApi.getSetting(Params, true)
          .then(data => {
            self.loading = false;
            self.form = data.data.vars.values;
            self.address = data.data.address;
          })
          .catch(error => {});
      },
      /*点击保存*/
      onSubmit() {
        let self = this;

        let params = self.form;
        self.loading = true;
        MinistoreApi.saveSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ministore/setting/setting.vue